"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapper$ = exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapper$outboundSchema = exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapper$inboundSchema = void 0;
exports.fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapperToJSON = fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapperToJSON;
exports.fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapperFromJSON = fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapperFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const timeonmarket_js_1 = require("./timeonmarket.js");
const timeonmarketbypropertytype_js_1 = require("./timeonmarketbypropertytype.js");
/** @internal */
exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapper$inboundSchema = z.object({
    national: timeonmarket_js_1.TimeOnMarket$inboundSchema,
    property_type: z.array(timeonmarketbypropertytype_js_1.TimeOnMarketByPropertyType$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "property_type": "propertyType",
    });
});
/** @internal */
exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapper$outboundSchema = z.object({
    national: timeonmarket_js_1.TimeOnMarket$outboundSchema,
    propertyType: z.array(timeonmarketbypropertytype_js_1.TimeOnMarketByPropertyType$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        propertyType: "property_type",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapper$;
(function (FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapper$) {
    /** @deprecated use `FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapper$inboundSchema` instead. */
    FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapper$.inboundSchema = exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapper$inboundSchema;
    /** @deprecated use `FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapper$outboundSchema` instead. */
    FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapper$.outboundSchema = exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapper$outboundSchema;
})(FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapper$ || (exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapper$ = FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapper$ = {}));
function fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapperToJSON(fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapper) {
    return JSON.stringify(exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapper$outboundSchema
        .parse(fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapper));
}
function fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapper$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageTimeOnMarketNationalResponsesTimeOnMarketWrapper' from JSON`);
}
//# sourceMappingURL=fastapikrakenendpointsstatsmodelslettingsnationalgetaveragetimeonmarketnationalresponsestimeonmarketwrapper.js.map